module.exports = __webpack_public_path__ + "img/account-book.10b2d9ff.svg";